export class TransactionReceiptResponseDto {
  public css: string;
  public html: string;
}
